import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { transparentize } from 'polished';
import animation from './animation';
import colors from './colors';
import { outlines } from './focus';
var sizes = {
  small: {
    borderRadius: 40,
    fontSize: 14,
    lineHeight: 20
  },
  medium: {
    borderRadius: 24,
    fontSize: 18,
    lineHeight: 24
  },
  large: {
    borderRadius: 40,
    fontSize: 24,
    lineHeight: 32
  }
};
var spacing = {
  small: {
    paddingLeft: 19,
    paddingRight: 19,
    paddingTop: 8,
    paddingBottom: 10
  },
  medium: {
    paddingLeft: 23,
    paddingRight: 23,
    paddingTop: 9,
    paddingBottom: 13
  },
  large: {
    paddingLeft: 31,
    paddingRight: 31,
    paddingTop: 13,
    paddingBottom: 17
  }
};
var withArrowSpacing = {
  small: {
    paddingLeft: 19,
    paddingRight: 15,
    paddingTop: 8,
    paddingBottom: 10
  },
  medium: {
    paddingLeft: 23,
    paddingRight: 19,
    paddingTop: 9,
    paddingBottom: 13
  },
  large: {
    paddingLeft: 31,
    paddingRight: 21,
    paddingTop: 13,
    paddingBottom: 17
  }
};
var buttons = {
  variants: {
    white: {
      background: colors.primaryWhite,
      color: colors.primaryIndigo,
      border: "1px solid ".concat(colors.primaryWhite),
      ':hover': {
        background: 'rgba(255, 255, 255, 0.9)',
        borderColor: 'transparent'
      },
      ':active': {
        background: 'rgba(255, 255, 255, 0.9)',
        borderColor: 'transparent'
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    transparent: {
      background: colors.primaryWhite,
      color: colors.primaryBlue,
      border: "1px solid ".concat(colors.primaryBlue),
      ':hover': {
        background: 'rgba(69, 91, 237, 0.06)',
        borderColor: colors.primaryBlueHover
      },
      ':active': {
        background: 'rgba(69, 91, 237, 0.06)',
        borderColor: colors.primaryBlueHover
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    transparentWhite: {
      background: 'transparent',
      color: colors.primaryWhite,
      border: "1px solid ".concat(colors.primaryWhite),
      ':hover': {
        background: 'transparent',
        borderColor: 'rgba(255, 255, 255, 0.7)'
      },
      ':active': {
        background: 'transparent',
        borderColor: 'rgba(255, 255, 255, 0.7)'
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    primary: {
      background: colors.primaryBlue,
      color: colors.primaryWhite,
      border: "1px solid ".concat(colors.primaryBlue),
      ':hover': {
        background: colors.primaryBlueHover,
        borderColor: colors.primaryBlueHover
      },
      ':active': {
        background: colors.primaryBlueActive,
        borderColor: colors.primaryBlueActive
      },
      ':focus': _objectSpread({}, outlines["default"])
    },
    secondary: {
      background: colors.primaryWhite,
      color: colors.primaryIndigo,
      border: '1px solid #CDCCD7'
    },
    secondaryBlue: {
      background: colors.primaryWhite,
      border: "1px solid ".concat(colors.primaryBlue),
      color: colors.primaryBlue,
      '&:hover': {
        background: transparentize(0.94, colors.primaryBlue)
      },
      '&:active': {
        background: transparentize(0.94, colors.primaryBlue)
      },
      '&:focus': _objectSpread({}, outlines["default"])
    },
    dark: {
      background: 'transparent',
      color: colors.primaryWhite,
      border: '1px solid rgba(255, 255, 255, 0.4)',
      transition: 'border-color ' + animation.transitionDuration,
      '&:hover': {
        background: 'transparent',
        borderColor: 'rgba(255, 255, 255, 0.1)'
      },
      '&:active': {
        background: 'transparent',
        borderColor: 'rgba(255, 255, 255, 0.1)'
      },
      '&:focus': _objectSpread({}, outlines["default"])
    },
    dropdown: {
      textAlign: 'left',
      color: colors.primaryIndigo,
      background: colors.primaryWhite,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: transparentize(0.8, colors.primaryIndigo),
      borderRadius: 40,
      '&& > span': {
        paddingRight: 48,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '&:hover': {
        borderColor: transparentize(0.6, colors.primaryIndigo)
      },
      '&:active, &[aria-expanded="true"]': {
        borderColor: colors.primaryIndigo
      }
    }
  },
  sizes: sizes,
  spacing: spacing,
  withArrowSpacing: withArrowSpacing
};
export default buttons;